import React from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

interface IReferenceProps {
	reference?: string;
}

export const Reference = ({ reference }: IReferenceProps) => {
	const { t } = useTranslation();

	if (!reference) {
		return null;
	}

	return (
		<p>
			{t('web_parking_confirmation_reference_number')}
			{': '}
			<strong>{reference}</strong>
		</p>
	);
};
